import { Response as Application } from 'api/typegen/client/application/get';
import { Response as Client } from 'api/typegen/client/get';

export const isValidApplication = (
  application: Application | null | undefined,
  client?: Client | null | undefined,
) => {
  const applicationValidation = application?.status && !application?.closed;
  // client validation applied if it's possible but not mandatory
  const clientAppValidation =
    !client ||
    (client?.availableProducts || []).includes(
      application?.productInfo?.number || 'no-defined',
    );
  return applicationValidation && clientAppValidation;
};
